<template>
  <div class="hello" id="DayReport">
    <div class="data_head">
      <span class="text_panel">参数</span>
      <el-cascader
        v-model="measureNos"
        :options="paramOptions"
        :props="{value:'code',label:'name',children:'childHashSet',emitPath:false,multiple:true}"
        :show-all-levels="false"
        collapse-tags
      ></el-cascader>
      <el-date-picker
        v-model="searchDate"
        align="right"
        type="date"
        value-format="yyyy-MM-dd"
        :editable="false"
      ></el-date-picker>
      <el-button type="primary" @click="search()" class="searchButton">查&nbsp;询</el-button>
      <el-button type="primary" class="searchButton" @click="download()">批量下载</el-button>
    </div>

    <div class="table tableContent" style="height:625px;" id="table">
      <el-scrollbar style="height:100%">
        <div class="table_panel">
        </div>
        <el-table :data="list" style="width: 100%;" :header-cell-style="{background:'#335ABB',color:'#FFF'}"
                  :row-style="{height:'36px'}" stripe>
          <el-table-column prop="measureNo" label="测点编号"></el-table-column>
          <el-table-column prop="normalRange" label="正常值范围"></el-table-column>
          <el-table-column prop="maxValueTime" label="最大值时间"></el-table-column>
          <el-table-column prop="maxValue" label="最大值">
            <template slot-scope="scope">
              <span>{{ scope.row.maxValue | rounding }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="minValueTime" label="最小值时间"></el-table-column>
          <el-table-column prop="minValue" label="最小值">
            <template slot-scope="scope">
              <span>{{ scope.row.minValue | rounding }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="avgValue" label="平均值">
            <template slot-scope="scope">
              <span>{{ scope.row.avgValue | rounding }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
    import Vue from "vue";

    Vue.filter("rounding", function (value) {
        if (!value) return "--";
        return parseFloat(value).toFixed(4);
    });

    export default {
        name: "DayReport",
        data() {
            return {
                measureNos: [],
                paramOptions: [],
                list: [],
                searchDate: "",
                projectName: "",
                objcontent: "",
                date: null,
            };
        },
        mounted: function () {
            this.$axios.get("/api/monitor/dataHistory/getMeasureByCode").then((res) => {
                this.paramOptions = res.data.datas.values;
            });
            this.yestertay();
        },
        methods: {
            yestertay(){
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth()+1;
                let day = date.getDate() - 1;
                this.searchDate = year + '-' + month + '-' + day;
            },
            search() {
                this.$axios.get(`/api/monitor/report/getReport?code=${this.measureNos}&time=${this.searchDate}&type=1`).then((res) => {
                    this.list = res.data.datas.values;
                });
            },
            download() {
                const req = {
                    type:"1"
                };
                this.$axios
                    .post("/api/monitor/report/exportReport", req ,{ responseType: "blob" })
                    .then((res) => {
                        let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'}); //xlsx类型
                        let downloadElement = document.createElement('a');
                        let href = window.URL.createObjectURL(blob); // 创建下载的链接
                        downloadElement.href = href;
                        downloadElement.download = "日报表数据.xls"; // 下载文件名
                        document.body.appendChild(downloadElement);
                        downloadElement.click(); // 点击下载
                        document.body.removeChild(downloadElement); // 下载完成移除元素
                        window.URL.revokeObjectURL(href); // 释放掉blob对象
                    });
            },
        },
    };
</script>

<style>
  #table .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  #DayReport .el-cascader .el-input  .el-input__inner{
    color: #FFF;
    background-color: #3457DE;
  }

  #DayReport .el-date-editor .el-input__inner{
    background-color: #3457DE;
    color: #FFF;
  }

  #DayReport .el-table{
    color: #A7CCF6;
  }

  #DayReport .el-table__row {
    background-color: #0B3A68 !important;
  }

  #DayReport .el-table--striped .el-table__body tr.el-table__row--striped td{
    background-color: #021535;
  }

  #DayReport .el-table td{
    border: unset;
  }

  #DayReport .el-table th.is-leaf{
    border-bottom: none;
  }

  #DayReport .el-date-editor--daterange.el-input__inner{
    background-color: #3457DE;
  }

  #DayReport .el-date-editor .el-range-input{
    background-color: #3457DE;
    color: #FFF;
  }

  #DayReport .el-date-editor .el-range-separator{
    background-color: unset;
    color: #FFF;
  }

</style>

<style scoped>
  @import url('../../assets/css/style.css');
</style>




// WEBPACK FOOTER //
// src/components/reportManage/DayReport.vue